export const injectStyleSheet = (cssText) => {
    const style = document.createElement('style');
    style.textContent = cssText;
    style.setAttribute('data-theme', '');
    return document.head.appendChild(style);
};
export const loadStyleSheet = (source) => {
    return new Promise((resolve, reject) => {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = source;
        link.onload = () => {
            resolve(link);
        };
        link.onerror = () => {
            reject(new Error(`stylesheet not loaded: ${source}`));
        };
        document.head.appendChild(link);
    });
};
export const loadScript = (source) => {
    return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = source;
        script.async = true;
        script.onload = () => {
            resolve(script);
        };
        script.onerror = () => {
            reject(new Error(`script not loaded: ${source}`));
        };
        document.body.appendChild(script);
    });
};
export const copy = (string) => navigator.clipboard.writeText(string).catch(() => {
    let el;
    try {
        el = document.createElement('textarea');
        el.value = string;
        el.setAttribute('readonly', '');
        el.style.position = 'absolute';
        el.style.left = '-9999px';
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
    }
    catch {
        if (el) {
            document.body.removeChild(el);
        }
        throw new Error('copy failed');
    }
});
export const scrollToElement = (target) => {
    if (!target)
        return;
    const { top, bottom } = target.getBoundingClientRect();
    const isInViewportByY = top >= 0 && bottom <= window.innerHeight;
    if (isInViewportByY)
        return;
    const shouldScrollToBottom = top > window.innerHeight / 2;
    const offset = shouldScrollToBottom
        ? window.pageYOffset + (bottom - window.innerHeight)
        : top + window.pageYOffset - 80;
    try {
        window.scrollTo({
            left: 0,
            top: offset,
            behavior: 'smooth'
        });
    }
    catch {
        window.scrollTo(0, offset);
    }
};
